import { useSelector } from "react-redux";

import BilderAndObservasjonsbilder from "./BilderAndObservasjonsbilder";

import { toNorwegianDatetime } from "../../utils/date";
import { getDatoSortedImages } from "../../utils/imageUtils";

const cleanMiljogebyrBilderForDatoSortedBilder = (
  miljogebyrBilder,
  miljogebyr
) => {
  if (
    !miljogebyr ||
    !miljogebyr.ileggelsesdatoTil ||
    !miljogebyrBilder ||
    miljogebyrBilder.length < 0
  ) {
    return [];
  }

  return [
    {
      dato: toNorwegianDatetime(miljogebyr.ileggelsesdatoTil).format(
        "DD.MM.YYYY"
      ),
      tidspan: toNorwegianDatetime(miljogebyr.ileggelsesdatoTil).format(
        "HH:mm"
      ),
      images: [...miljogebyrBilder],
    },
  ];
};

export default function BilderAndObservasjonsbilderContainer() {
  const klageMiljoKontrollThumbnailImage = useSelector(
    (state) => state.klageMiljoKontrollThumbnailImage
  );
  const klageMiljoKontrollLightboxImage = useSelector(
    (state) => state.klageMiljoKontrollLightboxImage
  );
  const klageIleggelseThumbnailImage = useSelector(
    (state) => state.klageIleggelseThumbnailImage
  );
  const klageIleggelseLightboxImage = useSelector(
    (state) => state.klageIleggelseLightboxImage
  );
  const klageIleggelse = useSelector((state) => state.klageIleggelse);

  let datoSortedThumbnailBilder = [];

  const miljoKontrollerThumbnailBilder = getDatoSortedImages(
    klageMiljoKontrollThumbnailImage
  );
  if (
    miljoKontrollerThumbnailBilder &&
    miljoKontrollerThumbnailBilder.length > 0
  ) {
    datoSortedThumbnailBilder = [...miljoKontrollerThumbnailBilder];
  }

  const miljogebyrThumbnailBilder = cleanMiljogebyrBilderForDatoSortedBilder(
    klageIleggelseThumbnailImage,
    klageIleggelse
  );
  if (miljogebyrThumbnailBilder && miljogebyrThumbnailBilder.length > 0) {
    datoSortedThumbnailBilder = [
      ...datoSortedThumbnailBilder,
      ...miljogebyrThumbnailBilder,
    ];
  }

  let datoSortedLightboxBilder = [];

  const miljoKontrollerLightboxBilder = getDatoSortedImages(
    klageMiljoKontrollLightboxImage
  );
  if (
    miljoKontrollerLightboxBilder &&
    miljoKontrollerLightboxBilder.length > 0
  ) {
    datoSortedLightboxBilder = [...miljoKontrollerLightboxBilder];
  }

  const miljogebyrLightboxBilder = cleanMiljogebyrBilderForDatoSortedBilder(
    klageIleggelseLightboxImage,
    klageIleggelse
  );
  if (miljogebyrLightboxBilder && miljogebyrLightboxBilder.length > 0) {
    datoSortedLightboxBilder = [
      ...datoSortedLightboxBilder,
      ...miljogebyrLightboxBilder,
    ];
  }

  return (
    <BilderAndObservasjonsbilder
      miljogebyr={klageIleggelse}
      miljogebyrThumbnailBilder={klageIleggelseThumbnailImage || []}
      datoSortedThumbnailBilder={datoSortedThumbnailBilder}
      datoSortedLightboxBilder={datoSortedLightboxBilder}
    />
  );
}
